"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accounts = void 0;
const Account_1 = require("../types/Account");
const ApiResponse_1 = require("../types/ApiResponse");
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of accounts for the requested category.
 *
 * @param type Account category, for example `blacklist` or `genesis`.
 *
 * @example
 *
 * `accounts("blacklist")`
 */
function accounts(type) {
    return __awaiter(this, void 0, void 0, function* () {
        const queryParams = { type };
        try {
            const res = yield axios_1.default.request({
                url: "/data/accounts",
                params: queryParams,
                transformResponse: (result) => {
                    const json = JSON.parse(result);
                    if (json.error) {
                        return new ApiResponse_1.ApiResponse(undefined, { code: json.code, errorMessage: json.errorMessage });
                    }
                    const accountsData = json.data.map((value) => {
                        return Account_1.Account.fromJson(value);
                    });
                    return new ApiResponse_1.ApiResponse(accountsData);
                }
            });
            return yield res.data;
        }
        catch (err) {
            throw err.response.data;
        }
    });
}
exports.accounts = accounts;
//# sourceMappingURL=accounts.js.map